module.exports = [
  { ident: 'books', text: 'Bücher', color: '#c37868' },
  { ident: 'garden', text: 'Blumen & Garten', color: '#1f9b8c' },
  { ident: 'food', text: 'Essen & Trinken', color: '#dc9d52' },
  { ident: 'mobility', text: 'Mobilität', color: '#4f9099' },
  { ident: 'creative', text: 'Kreativität', color: '#8d6aa0' },
  { ident: 'music', text: 'Musik', color: '#7e562b' },
  { ident: 'games', text: 'Spielwaren', color: '#4e8ac8' },
  { ident: 'others', text: 'Anderes', color: '#747474' }
]
